import { CSSResultGroup, TemplateResult, html } from 'lit';
import {
  LightDomStyles,
  OutlineElement,
  SlotsController,
} from '@phase2/outline-core';
import { customElement } from 'lit/decorators.js';
import componentStyles from './outline-contact-card.css.lit';
import '../outline-button-baseline/outline-button-baseline';
import '../outline-icon-baseline/outline-icon-baseline';
import buttonStyles from '../outline-button-baseline/outline-button-baseline.css.lit';

/**
 * The OutlineContactCard component
 * @element outline-contact-card
 */
@customElement('outline-contact-card')
export class OutlineContactCard extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles, buttonStyles];
  lightDomStyles = new LightDomStyles(
    this,
    componentStyles,
    this.tagName.toLowerCase()
  );

  slots = new SlotsController(this);

  render(): TemplateResult {
    return html`
      <article class="container">
        <div class="content">
          ${this.slots.conditionalSlot('name', false)}
          <hr class="rule" />
          ${this.slots.conditionalSlot('title', false)}
          <div class="contact-info">
            ${this.slots.conditionalSlot('phone', false)}
            ${this.slots.conditionalSlot('email', false)}
          </div>
          ${this.slots.conditionalSlot('cta', false)}
        </div>
      </article>
    `;
  }
}
